import { c as _c } from "react/compiler-runtime";
import { Button } from "@chakra-ui/react";
import { IoIosLink } from "react-icons/io";
const ShareSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Button aria-label="Copy link to this page" variant="ghost" disabled={true} background="transparent" textStyle="textMedium" color="white"><IoIosLink /> Copy link to this page</Button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default ShareSkeleton;